import { render, staticRenderFns } from "./ProfileRemoveAccount.vue?vue&type=template&id=4eb71458&"
import script from "./ProfileRemoveAccount.vue?vue&type=script&lang=js&"
export * from "./ProfileRemoveAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports